import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {AuthGuard} from './auth.guard'
import { SigninComponent } from './signin/signin.component';
import { SignupComponent } from './signup/signup.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SubscriptionPromptComponent } from './subscription-prompt/subscription-prompt.component';
import { SuccessfulComponent } from './successful/successful.component';
import { PopupComponent } from './popup/popup.component';
import { AccountSettingsComponent } from './account-settings/account-settings.component';
import { BreakdownComponent } from './breakdown/breakdown.component';
import { CheckoutComponent } from './checkout/checkout.component';


const routes: Routes = [ 
{path:'',redirectTo: 'signin',pathMatch:'full'},
{path:'signin',component:SigninComponent},
{path:'subscription-prompt',component:SubscriptionPromptComponent},
{path:'signup',component:SignupComponent},
{path:'dashboard',component:DashboardComponent},
{path:'success',component:SuccessfulComponent},
{path:'popup',component:PopupComponent},
{path:'settings',component:AccountSettingsComponent},
{path:'breakdown',component:BreakdownComponent},
{path:'checkout',component:CheckoutComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
